/**
 * @fileoverview Job Review Windows page
 *
 * URL: /dashboard/jobs/:jobId/calendar/review-windows
 *
 * Sibling of the Key Dates page. Renders the dedicated
 * `InvestigationWindowsPanel` table that the practitioner uses to
 * scope preference / uncommercial / related-party / PPSA-vesting
 * recoveries. Lives at its own route (rather than being inlined on
 * the calendar) so practitioners can deep-link / bookmark / share
 * the recovery review surface without scrolling past a calendar.
 */

import { createFileRoute } from "@tanstack/react-router";

import type { Id } from "@cvx/_generated/dataModel";

import { InvestigationWindowsPanel } from "@/calendar";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/calendar/review-windows",
)({
  component: JobReviewWindowsPage,
});

function JobReviewWindowsPage() {
  const { jobId } = Route.useParams();
  const typedJobId = jobId as Id<"jobs">;

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Review Windows
        </h1>
        <p className="text-sm text-muted-foreground">
          A list of the review windows applicable to your job. Select a row to
          view the relevant section of the Corporations Act 2001 (Cth) or
          Bankruptcy Act 1966 (Cth).
        </p>
      </div>

      <InvestigationWindowsPanel jobId={typedJobId} />
    </div>
  );
}
